import {Action, Dispatch, Middleware} from 'redux';

import BenchlingConfig from 'BenchlingConfig';

export function syncerConsoleDebug(message: string, context?: Object): void {
  if (BenchlingConfig.ENABLE_SYNCER_DEBUGGING) {
    /* eslint-disable no-console */
    console.debug(message);
    if (context) {
      console.group('Context objects');
      console.debug(context);
      console.groupEnd();
    }
    /* eslint-enable no-console */
  }
}

// Middleware which captures redux actions for debugging.
export const captureActionsForDebuggingReduxMiddleware: Middleware =
  () =>
  (next: Dispatch): Dispatch =>
  <A extends Action>(action: A): A => {
    if (BenchlingConfig.ENABLE_SYNCER_DEBUGGING) {
      syncerConsoleDebug(`Redux action captured ${action.type}`);
    }
    return next(action);
  };
